"use strict";
/* Phonenumber validator that allows swedish phonenumbers
starting with either 46... or 070... */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhonenumber = void 0;
const validatePhonenumber = (number) => {
    if (!number) {
        return false;
    }
    return /^(46|0)\s*(7[0236])\s*(\d{4})\s*(\d{3})$/.test(number);
};
exports.validatePhonenumber = validatePhonenumber;
//# sourceMappingURL=validate-phonenumber.js.map